module.exports = __webpack_public_path__ + "static/media/the-star.1dd6e595.svg";